<template>
    <div v-loading="dataLoading">
        <tab name="9">{{ userName }}(ID:{{ id }})</tab>
        <template v-if="seatData">
            <el-descriptions class="MT10" labelClassName="color-info" border>
                <el-descriptions-item label="座位图开通状态">
                    <span v-if="seatData.seatStatus == 1" class="color-info">未开通</span>
                    <span v-else-if="seatData.seatStatus == 2" class="color-warning">开通中 <el-button size="mini" type="text" icon="el-icon-refresh" @click="getSeatData">刷新</el-button></span>
                    <span v-else-if="seatData.seatStatus == 4" class="color-danger">开通失败</span>
                    <span v-else-if="seatData.seatStatus == 3" class="color-success">已开通</span>
                    <el-link :href="`${sswap}/pages/helpCenter/help/help?menuId=73`" target="_blank" type="warning" icon="el-icon-question" class="ML10">操作指引</el-link>
                </el-descriptions-item>
                <template v-if="seatData.seatStatus == 3">
                    <el-descriptions-item label="云图场地名称">{{seatData.siteName}}</el-descriptions-item>
                    <el-descriptions-item label="云图场地编号">
                        {{seatData.seatCode}}
                        <el-link :href="ancoe" target="_blank" type="primary">去云图查询<i class="el-icon-right"></i></el-link>
                    </el-descriptions-item>
                </template>
                <el-descriptions-item label="座位图数据获取方式">
                    <span>{{seatData.useHtAnt == 1 ? '爬虫获取' : 'API读取'}}</span> 
                    <el-popover
                        v-if="$utils.have('/site/updateUseHtAnt') && seatData.seatStatus > 2"
                        placement="top"
                        width="300"
                        v-model="updateUseHtAntPopover">
                        <div class="popover-content-box">
                            <div class="MB20">两种方式获取云图的数据，如果其中一种经常失败，可以尝试换一种方式</div>
                            <el-radio-group v-model="useHtAnt" size="mini">
                                <el-radio :label="0" border>API读取</el-radio>
                                <el-radio :label="1" border>爬虫获取</el-radio>
                            </el-radio-group>
                            <div class="MT20 color-info">
                                <div><small>API读取：通过调用云图提供的 API, 读取场馆座位图信息</small></div>
                                <div><small>爬虫获取：通过爬虫的方式, 从云图后台页面提取场馆座位图信息</small></div>
                            </div>
                        </div>
                        <div class="popover-btn-box MT20">
                            <el-button size="mini" @click="useHtAnt = seatData.useHtAnt; updateUseHtAntPopover = false">取消</el-button>
                            <el-button type="primary" size="mini" @click="updateUseHtAnt()">确定</el-button>
                        </div>
                        <el-button icon="el-icon-edit" size="mini" type="text" slot="reference">更改</el-button>
                    </el-popover>
                </el-descriptions-item>
            </el-descriptions>
            <div v-if="seatData.seatStatus == 4 && seatData.failReason" class="MT10">
                <el-alert title="失败原因" :closable="false" type="error">
                    {{seatData.failReason}}
                </el-alert>
            </div>
            <!-- 未开通 || 开通中 -->
            <el-card v-if="seatData.seatStatus != 3" class="status0 MT10">
                <div class="step-box">
                    <div class="step">
                        <div class="label">STEP1：</div>
                        <div class="info">
                            <div class="title">创建场地并绘制座位</div>
                            <div class="desc color-info MT10">
                                请到
                                <el-link :href="ancoe" target="_blank" type="primary">太合云图管理后台<i class="el-icon-right"></i></el-link>
                                （基础管控-场馆管理），按照场地的信息创建一个场地，并且绘制好场地内场馆座位图。
                                <el-link :href="`${sswap}/pages/helpCenter/help/help?menuId=72`" target="_blank" type="warning" icon="el-icon-question">操作指引</el-link>
                            </div>
                        </div>
                    </div>
                    <div class="step">
                        <div class="label">STEP2：</div>
                        <div class="info">
                            <div class="title">复制场地编号</div>
                            <div class="desc color-info MT10">找到创建好的场地编号并复制。</div>
                        </div>
                    </div>
                    <div class="step">
                        <div class="label">STEP3：</div>
                        <div class="info">
                            <div class="title">输入场地编号</div>
                            <div class="desc color-info MT10">将复制后的场地编号粘贴到以下输入框中。</div>
                            <div class="form MT15">
                                <el-input placeholder="请输入云图场地编号" v-model.trim="seatCode" :disabled="seatData.seatStatus == 2 ? true : false"></el-input>
                                <div class="MT15">
                                    <el-button type="primary" :disabled="seatData.seatStatus == 2 || !seatCode ? true : false" :loading="btnLoading" @click="openSeat()">开通座位图</el-button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </el-card>
            <!-- 已开通 -->
            <template v-else>
                <el-card class="MT10">
                    <div slot="header" class="card-header">
                        <div class="title">座位图数据版本</div>
                        <el-button type="primary" size="mini" icon="el-icon-refresh" @click="$refs.updateSeatMap.show(id)">获取最新版本</el-button>
                    </div>
                    <el-table :data="seatData.seatVersionList" style="width: 100%;" size="mini" border>
                        <el-table-column type="expand" label="展开">
                            <template slot-scope="{row} = scope">
                                <div class="color-danger PD10">{{row.failReason}}</div>
                            </template>
                        </el-table-column>
                        <el-table-column label="数据版本" prop="version"></el-table-column>
                        <el-table-column label="同步状态" prop="status">
                            <template slot="header">
                                同步状态 <el-button size="mini" type="text" icon="el-icon-refresh" @click="getSeatData"></el-button>
                            </template>
                            <template slot-scope="{row} = scope">
                                <el-tag v-if="row.status  == 3" type="success" size="mini">已同步</el-tag>
                                <el-tag v-else-if="row.status  == 4" type="danger" size="mini">同步失败</el-tag>
                                <el-tag v-else type="warning" size="mini">同步中</el-tag>
                            </template>
                        </el-table-column>
                        <el-table-column label="演出数" prop="activityIds">
                            <template slot-scope="{row} = scope">
                                <el-button v-if="row.activityIds" type="text" size="mini" @click="showActivity(row.activityIds)">{{row.activityIds.length}}场</el-button>
                                <span v-else>0场</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="最后同步时间" prop="createTime" min-width="150"></el-table-column>
                        <el-table-column label="操作人" prop="createUserName"></el-table-column>
                        <el-table-column label="更新备注" prop="remark">
                            <template slot-scope="{row} = scope">
                                <el-tooltip effect="dark" placement="top-start">
                                    <div slot="content" class="remark">{{row.remark}}</div>
                                    <div class="ellipsis">{{row.remark}}</div>
                                </el-tooltip>
                            </template>
                        </el-table-column>
                    </el-table>
                </el-card>
                <el-card v-if="versionList.length > 0" class="MT10" header="座位图预览">
                    <div class="page-filter-box">
                        <el-row :gutter="20">
                            <el-col :xs="24" :sm="12" :md="8" :xl="4">
                                <el-select v-model="previewParams.theaterId" placeholder="请选择数据版本" @change="getAllHall" size="small">
                                    <el-option v-for="(item,index) in versionList" :label="`${item.version}(${item.createTime})`" :value="item.theaterId" :key="index"></el-option>
                                </el-select>
                            </el-col>
                            <el-col :xs="24" :sm="12" :md="8" :xl="4">
                                <el-select v-model="previewParams.hallId" placeholder="请选场馆" size="small" @change="seatPreview">
                                    <el-option v-for="(item,index) in hallList" :label="`${item.name}`" :value="item.hallId" :key="index"></el-option>
                                </el-select>
                            </el-col>
                            <!-- <el-col :xs="24" :sm="12" :md="8" :xl="4" class="page-filter-btns">
                                <el-button type="primary" icon="el-icon-view" @click="seatPreview" size="small">查看</el-button>
                            </el-col> -->
                        </el-row>
                    </div>
                    <div v-loading="regionLoading">
                        <el-radio-group v-if="regionInfo && regionInfo.length > 1" v-model="previewParams.floorId" size="small" @change="floorChange">
                            <el-radio-button v-for="(item,index) in regionInfo" :label="item.floorId" :key="index">{{item.floorName}}</el-radio-button>
                        </el-radio-group>
                        <div v-if="regionData" class="region-box MT20">
                            <div :style="`transform: scale(${scale})`">
                                <el-image v-if="regionData.floorPic" :src="regionData.floorPic" @load="floorPicLoad" class="floor-pic"></el-image>
                                <div class="area" v-for="(item, index) in regionData.regionList" :key="index"
                                    :style="`${item.shapeStyle}`" @click="showSeat(item)">
                                    <div :class="item.nclass" :style="`${item.nstyle}`"></div>
                                    <div v-if="item.nstyle2" :class="item.nclass2" :style="`${item.nstyle2};background:#fff;`"></div>
                                    <div class="name" :style="`${item.fzzStyle}`">{{item.regionName}}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </el-card>
                <update-seat-map ref="updateSeatMap" @onUpdate="getSeatData"></update-seat-map>
                <seat-view v-if="regionData" ref="seatView"></seat-view>
            </template>
        </template>
    </div>
</template>

<script>
import Tab from './components/tab';
import UpdateSeatMap from './components/updateSeatMap.vue'
import SeatView from './components/seatView.vue';
export default {
    props: {
        id: {
            type: [Number, String],
            default: ''
        }
    },
    components: {
        Tab,UpdateSeatMap,SeatView
    },
    data() {
        return {
            userName: '',
            ancoe:process.env.VUE_APP_ANCOE,
            sswap:process.env.VUE_APP_SSWAP_URL,
            dataLoading: false,
            btnLoading: false,
            seatData: null,
            seatCode: "",

            versionList: [],
            hallList: [],
            previewParams: {
                theaterId: "",
                hallId: "",
                floorId: ""
            },
            regionInfo: null,
            regionLoading: false,
            regionData: null,

            scale: 1,

            updateUseHtAntPopover: false,
            useHtAnt: 0
        }
    },
    mounted(){
        this.getSeatData();
    },
    methods: {
        // 获取详细数据
        getSeatData(){
            this.dataLoading = true;
            this.$request({
                url: "/site/seatInfo",
                params: { id: parseInt(this.id) },
                method: "post",
            })
                .then((res) => {
                    const { state, msg, result } = res.data;
                    if (state == 1 && result) {
                        this.seatData = result;
                        this.userName = result.name;
                        this.seatCode = result.seatCode || ""
                        this.useHtAnt = result.useHtAnt || 0
                        if(result.seatStatus == 3){
                            this.getAllVersion();
                        }
                    }else{
                       this.$message.error(msg || "获取信息失败,请重试"); 
                    }
                })
                .catch(() => {
                    this.$message.error("获取信息失败,请重试");
                })
                .finally(() => {
                    this.dataLoading = false;
                });
        },
        //开通座位
        openSeat(){
            this.btnLoading = true;
            this.$request({
                url: "/site/openSeat",
                params: { 
                    id: this.id,  
                    seatCode: this.seatCode
                },
                method: "post",
            })
                .then((res) => {
                    const { state, msg } = res.data;
                    if (state == 1) {
                        this.getSeatData();
                    }else{
                       this.$message.error(msg || "操作失败,请重试"); 
                    }
                })
                .catch(() => {
                    this.$message.error("操作失败,请重试");
                })
                .finally(() => {
                    this.btnLoading = false;
                });
        },
        //查看演出
        showActivity(ids){
            this.$router.push({
                path: '/activityManage/activity/list',
                query: {
                    searchValue: ids.toString()
                },
            });
        },
        //获取版本
        getAllVersion(){
            this.$request({
                url: "/site/getAllVersion",
                params: { 
                    siteId: this.id,  
                },
                method: "post",
            })
                .then((res) => {
                    const { state, msg, result} = res.data;
                    if (state == 1) {
                        this.versionList = result || []
                        if( this.versionList.length > 0 ){
                            this.previewParams.theaterId =  this.versionList[0].theaterId
                            this.getAllHall()
                        }
                    }else{
                       this.$message.error(msg || "获取版本数据失败,请重试"); 
                    }
                })
                .catch(() => {
                    this.$message.error("获取版本数据失败,请重试");
                })
        },
        //获取场馆
        getAllHall(){

            this.hallList = [];
            this.previewParams.hallId = "";
            this.regionInfo = null
            this.previewParams.floorId = ""
            this.regionData = null

            this.$request({
                url: "/site/getAllHall",
                params: { 
                    theaterId: this.previewParams.theaterId,
                },
                method: "post",
            })
                .then((res) => {
                    const { state, msg, result} = res.data;
                    if (state == 1) {
                        this.hallList = result || []
                    }else{
                       this.$message.error(msg || "获取场馆数据失败,请重试"); 
                    }
                })
                .catch(() => {
                    this.$message.error("获取场馆数据失败,请重试");
                })
        },
        //座位图预览
        seatPreview(){
            if( !this.previewParams.hallId ){
                return this.$message.error('请选择场馆！');
            }
            this.regionLoading = true;
            this.$request({
                url: "/site/seatPreviewFloor",
                params: { 
                    hallId: this.previewParams.hallId,
                },
                method: "post",
            })
                .then((res) => {
                    const { state, msg, result} = res.data;
                    if (state == 1) {
                        if( result && result.floorList && result.floorList.length > 0 ){
                            this.regionInfo = result.floorList
                            this.previewParams.floorId = this.regionInfo[0].floorId
                            this.regionData = this.regionInfo[0]
                        }
                    }else{
                       this.$message.error(msg || "获取预览数据失败,请重试"); 
                    }
                })
                .catch(() => {
                    this.$message.error("获取预览数据失败,请重试");
                }).finally(() => {
                    this.regionLoading = false;
                });
        },
        //选择楼层
        floorChange(e){
            this.regionData = this.regionInfo.find(v => v.floorId == e)
        },
        //地图加载
        floorPicLoad(e){
            const w = e.target.width, h = e.target.height;
            const n = Math.max(w, h);
            if( n > 750){
                this.scale = 750 / n
            }
        },
        //查看座位
        showSeat(item){
            if( item.regionKind == 1 ){
                this.$refs.seatView.show(this.previewParams.hallId,item)
            }
        },

        //更改座位图获取方式
        updateUseHtAnt(){
            this.updateUseHtAntPopover = false
            this.$request({
                url: "/site/updateUseHtAnt",
                params: { 
                    useHtAnt: this.useHtAnt,
                    id: this.id
                },
                method: "post",
            })
                .then((res) => {
                    const { state, msg} = res.data;
                    if (state == 1) {
                        this.seatData.useHtAnt = this.useHtAnt;
                    }else{
                        this.useHtAnt = this.seatData.useHtAnt
                       this.$message.error(msg || "操作失败,请重试"); 
                    }
                })
                .catch(() => {
                    this.useHtAnt = this.seatData.useHtAnt
                    this.$message.error("操作失败,请重试");
                })
        }
    },
}
</script>

<style lang="scss" scoped>
    ::v-deep .el-descriptions-item__container,
    ::v-deep .el-descriptions-item__content{
        // align-items: center;
        flex-wrap: wrap;
    }
    .status0{
        .step-box{
            .step{
                margin-bottom: 20px;
                display: flex;
                .label{
                    font-weight: 600;
                    color: #666;
                    position: relative;
                    &::after{
                        content: '';
                        position: absolute;
                        width: 70%;
                        border: 1px #666 solid;
                        left: 0;
                        top: 20px;
                    }
                }
                .title{
                    font-weight: 600;
                    font-size: 14px;
                }
                .desc{
                    display: flex;
                    align-items: center;
                }
            }
        }
        
    }
    .card-header{
        display: flex;
        align-items: center;
        justify-content: space-between;
    }

    .region-box{
        position: relative;
        height: 750px;
        overflow-x: auto;
        overflow-y: hidden;
        // background: #f8f8f8;
        > div {
            transform-origin: 0px 0px;
        }
        .area {
            position: absolute;
            overflow: hidden;
            > div{
                width: 100%;
                height: 100%;
                opacity: 0.3;
                cursor: pointer;
            }
            .huan1, .huan2 {
                border-radius: 50% 50% 0 0;
            }
            .huan2{
                position: absolute;
                top: 95%;
                left: 0;
            }
            .shan{
                border-radius: 50%;
            }
            .name{
                position: absolute;
                top: 50%;
                left: 50%;
                width: 60px;
                height: 20px;
                line-height: 20px;
                margin-top: -10px;
                margin-left: -30px;
                text-align: center;
                color: #fff;
                opacity: 1;
                font-weight: 700;
            }
        }
        .floor-pic{
            ::v-deep img{
                width: auto;
                height: auto;
            }
        }
    }

    .remark{
        white-space: pre-line;
    }
    .popover-btn-box{
        text-align: right;
    }
</style>